import React from "react";
import Navbar from "../components/navbar";
import { Footer } from "../components/Footer";
import MapComp from "../components/Map";
import {
  Box,
  Typography,
  Container,
  Grid,
  TextField,
  Button,
  Paper,
  IconButton,
  styled,
} from "@mui/material";
import { motion } from "framer-motion";

// Import Material Icons
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

// Styled components
const SocialIconBox = styled(Paper)(({ theme }) => ({
  width: "60px",
  height: "60px",
  margin: "",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 10,
  boxShadow: "0px 0px 3px #666",
  transition: "transform 0.2s, box-shadow 0.2s",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0px 0px 10px #666",
  },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: "50%",
  height: "50%",
}));

const FormTextField = styled(TextField)({
  marginBottom: "16px",
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "#666",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#333",
    },
  },
});

export const Contactus = () => {
  // Form state
  const [formData, setFormData] = React.useState({
    name: "",
    whatsapp: "",
    email: "",
    message: "",
  });

  // Social media links
  const socialLinks = [
    {
      icon: <FacebookIcon sx={{ fontSize: 60, color: "#1877F2" }} />,
      url: "https://www.facebook.com/share/QyxJ2wGN4eNRZxYC/?mibextid=WC7FNe",
      name: "Facebook",
    },
    {
      icon: <InstagramIcon sx={{ fontSize: 60, color: "#E4405F" }} />,
      url: "https://www.instagram.com/passion_pravesh_?igsh=NXA3dHZpaGxlajdw",
      name: "Instagram",
    },
    {
      icon: <YouTubeIcon sx={{ fontSize: 60, color: "#FF0000" }} />,
      url: "https://youtube.com/@yapassio_official?si=p79dHix1iVoJR-3g",
      name: "YouTube",
    },
    {
      icon: <LinkedInIcon sx={{ fontSize: 60, color: "#0A66C2" }} />,
      url: "https://www.linkedin.com/company/social-initiative-for-education-society/posts/?feedView=all",
      name: "LinkedIn",
    },
  ];

  // Contact method links
  const contactLinks = [
    {
      icon: <EmailIcon sx={{ fontSize: 60, color: "#EA4335" }} />,
      url: "https://mail.google.com/mail/?view=cm&fs=1&to=official@yapassio.com",
      name: "Email",
    },
    {
      icon: <WhatsAppIcon sx={{ fontSize: 60, color: "#25D366" }} />,
      url: `https://wa.me/${8931024213}`,
      name: "WhatsApp",
    },
    {
      icon: <PhoneIcon sx={{ fontSize: 60, color: "#128C7E" }} />,
      url: `tel:+8931024213`,
      name: "Phone",
    },
  ];

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Add your form submission logic here
      console.log("Form submitted:", formData);
      // Reset form after successful submission
      setFormData({
        name: "",
        whatsapp: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // Handler for social media and contact clicks
  const handleClick = (url, name) => {
    window.open(url, "_blank", "noopener,noreferrer");
    console.log(`Clicked ${name} link`);
  };

  // Handler for WhatsApp group button
  const handleWhatsAppGroup = () => {
    window.open(
      "https://chat.whatsapp.com/yourgrouplink",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Box>
      <Navbar />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Aclonica",
            fontSize: { xs: "40px", md: "50px" },
            py: 2,
          }}
        >
          Contact us!
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: "Roboto",
            fontSize: { xs: "16px", md: "20px" },
            mb: 4,
          }}
        >
          Have questions or need support? We're here to help you reach your
          educational goals!
        </Typography>
      </Container>

      <Box
        sx={{
          width: "100%",
          bgcolor: "#97D7E280",
          borderRadius: { xs: "50px 50px 0 0", md: "100px 100px 0 0" },
          px: { xs: 2, md: "8%" },
          py: 8,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            align="center"
            sx={{
              mb: 4,
              fontSize: { xs: "30px", md: "40px" },
              fontFamily: "Aclonica",
            }}
          >
            How can we Assist you?
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Typography variant="h6" sx={{ mb: 2, mt: 3 }}>
                Where to find us
              </Typography>
              <Box sx={{ height: { xs: "300px", md: "400px" }, mb: 2 }}>
                <MapComp />
              </Box>
              <Typography variant="h6">Offline center location</Typography>
            </Grid>

            <Grid item xs={12} md={7}>
              <Typography variant="h6" sx={{ mb: 2, mt: 3 }}>
                Fill out the form, and we'll be in touch quickly to support you!
              </Typography>

              <Paper sx={{ p: { xs: 2, md: 3 } }}>
                <Box component="form" onSubmit={handleSubmit}>
                  <FormTextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Name"
                    variant="outlined"
                    required
                  />
                  <FormTextField
                    fullWidth
                    label="WhatsApp Number"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleInputChange}
                    placeholder="Your Number"
                    variant="outlined"
                    type="tel"
                    required
                  />
                  <FormTextField
                    fullWidth
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Your Email"
                    variant="outlined"
                    type="email"
                    required
                  />
                  <FormTextField
                    fullWidth
                    label="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Type your query!"
                    variant="outlined"
                    multiline
                    rows={4}
                    required
                  />
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    sx={{
                      bgcolor: "#333",
                      height: "40px",
                      "&:hover": {
                        bgcolor: "#444",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box
        className="intern-bg"
        sx={{
          width: "100%",
          borderRadius: { xs: "50px 50px 0 0", md: "100px 100px 0 0" },
          px: { xs: 2, md: "8%" },
          py: 4,
        }}
      >
        <Container maxWidth="lg">
          {/* WhatsApp Group Button */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 6 }}>
            <Button
              variant="contained"
              startIcon={<WhatsAppIcon />}
              onClick={handleWhatsAppGroup}
              sx={{
                bgcolor: "#36BE49",
                borderRadius: "30px",
                minWidth: { xs: "280px", md: "330px" },
                height: "60px",
                fontSize: { xs: "16px", md: "20px" },
                mt: -8,
                "&:hover": {
                  bgcolor: "#2da03d",
                },
              }}
            >
              Join our General WhatsApp Group!
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              mb: 6,
              flexDirection: "column",
            }}
          >
            {/* Social Media Section */}
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "40px", md: "50px" },
                fontWeight: 500,
                fontFamily: "Aclonica",
                mb: 4,
              }}
            >
              Connect with us on
            </Typography>

            <div className="social-links-container">
              {socialLinks.map((social, index) => (
                <motion.div
                  key={index}
                  animate={{
                    y: [0, -10, 0], // Floating effect
                    background: [
                      "radial-gradient(circle, rgba(255, 0, 150, 0.3) 0%, transparent 70%)",
                      "radial-gradient(circle, rgba(0, 150, 255, 0.3) 0%, transparent 70%)",
                      "radial-gradient(circle, rgba(255, 0, 150, 0.3) 0%, transparent 70%)",
                    ], // Color change effect
                  }}
                  transition={{
                    duration: 2, // Animation speed
                    repeat: Infinity, // Infinite loop
                    ease: "easeInOut",
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0",
                    borderRadius: "50%",
                  }}
                >
                  <SocialIconBox
                    sx={{
                      position: "relative",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        background: "inherit", // Uses Framer Motion animation
                        borderRadius: "50%",
                        filter: "blur(20px)", // Glow effect
                        zIndex: -1,
                      },
                    }}
                  >
                    <StyledIconButton
                      onClick={() => handleClick(social.url, social.name)}
                      aria-label={`Visit our ${social.name}`}
                    >
                      {social.icon}
                    </StyledIconButton>
                  </SocialIconBox>
                </motion.div>
              ))}
            </div>

            {/* Contact Methods */}
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "20px", md: "25px" },
                fontWeight: 400,
                fontFamily: "Roboto",
                mt: 6,
                mb: 4,
              }}
            >
              or reach us through
            </Typography>

            <div
              style={{
                width: "100%",
                margin: "0 auto",
                justifyContent: "center",
                gap: "5px",
                flexWrap: "wrap",
                display: "flex",
              }}
            >
              {contactLinks.map((contact, index) => (
                <motion.div
                  key={index}
                  animate={{
                    y: [0, -10, 0], // Floating effect
                    background: [
                      "radial-gradient(circle, rgba(255, 0, 150, 0.3) 0%, transparent 70%)",
                      "radial-gradient(circle, rgba(0, 150, 255, 0.3) 0%, transparent 70%)",
                      "radial-gradient(circle, rgba(255, 0, 150, 0.3) 0%, transparent 70%)",
                    ], // Color transition
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    borderRadius: "50%",
                  }}
                >
                  <SocialIconBox
                    sx={{
                      position: "relative",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        width: "100px",
                        height: "100px",
                        background: "inherit",
                        borderRadius: "50%",
                        filter: "blur(20px)", // Neon blur effect
                        zIndex: -1,
                      },
                    }}
                  >
                    <StyledIconButton
                      onClick={() => handleClick(contact.url, contact.name)}
                      aria-label={contact.name}
                    >
                      {contact.icon}
                    </StyledIconButton>
                  </SocialIconBox>
                </motion.div>
              ))}
            </div>
          </Box>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};
